export const deliveryMethods = [
  {
    label: 'Classroom',
    value: 'classroom',
  },
  {
    label: 'Field',
    value: 'field',
  },
  {
    label: 'On-the-Job',
    value: 'on_the_job',
  }
];
